import clsx from "clsx";
import React from "react";

import "./shortcuts.title.scss";

export default ({ text, className }) => {
  return <h5 className={clsx("shortcuts-title", className)}>{text}</h5>;
};
